import { SubstitutesBloc as SubstitutesBlocComponent  } from './SubstitutesBloc.component'
import { connector } from './SubstitutesBloc.connector'

export const SubstitutesBloc = connector(SubstitutesBlocComponent)